import { useMutation } from "@apollo/client/react";
import { CONNECT_INVOICE_UPLOAD_UNIT_TO_CLIENT } from "../../mutations/documentHandler/connectInvoiceUploadUnitToClientIdentifier";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";

export const useConnectInvoiceUploadUnitToClient = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [connectInvoiceUploadUnitToClient, { data, loading, error }] =
    useMutation(CONNECT_INVOICE_UPLOAD_UNIT_TO_CLIENT, {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS, GET_CLIENTS_WITH_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    });

  return { connectInvoiceUploadUnitToClient, data, loading, error };
};
